import IconButton from "@mui/material/IconButton";

import {BmCheckIcon, BmCloseIcon} from "~/components/icons/simpleIcons";
import {designColors} from "~/ui";
import {BmBaseInfoBanner, BmBaseInfoBannerProps, commonStyles} from "~/components/banners";

export interface BmSuccessNotificationBannerProps
  extends Omit<BmBaseInfoBannerProps, "bodySx" | "colorPreset" | "leftColumn" | "rightColumn"> {
  closeButton?: boolean;
  onClose?: VoidFunction;
}

export const BmSuccessNotificationBanner: React.FC<BmSuccessNotificationBannerProps> = ({
  closeButton,
  onClose,
  ...restProps
}) => {
  return (
    <BmBaseInfoBanner
      {...restProps}
      bodySx={{flexWrap: "nowrap"}}
      colorPreset="green"
      leftColumn={<BmCheckIcon id="check-icon" color={designColors.colorInk} className={commonStyles.icon} />}
      rightColumn={
        closeButton ? (
          <IconButton onClick={onClose} disableRipple size="small">
            <BmCloseIcon id="close-icon" color={designColors.colorInk} />
          </IconButton>
        ) : undefined
      }
    />
  );
};
